export default __webpack_public_path__ + "static/media/ic-ticket.f7a8be32.svg";